import React from 'react';
import PropTypes from 'prop-types';

const Suspended = ({width = 26, height = 26}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 347 347"
    xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(10 10)" fill="none" fillRule="evenodd">
      <ellipse
        stroke="#3F53CA"
        strokeWidth="20"
        fill="#FFF"
        cx="163.5"
        cy="163.5"
        rx="163.5"
        ry="163.5"
      />
      <rect fill="#FB0000" x="91" y="55" width="146" height="218" rx="8" />
    </g>
  </svg>
);

Suspended.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

export default Suspended;



// WEBPACK FOOTER //
// ./src/components/Icon/svg/suspended.js